export default {
  description: 'Usa il codice: {{code}} per ottenere uno sconto sui tuoi prossimi {{count}} ordini quando ordini qui.',
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. Ordine',
    },
  },
  savings: {
    percentage: 'Risparmi un totale del {{totalSaved}}%',
    fixed: 'Risparmi un totale di {{totalSaved}}',
  },
  apply: 'Applica',
  applied: 'Applicato',
  remove: 'Rimuovi',
  custom_button: {
    done: 'Fatto',
  },
};
